import { RestSlice } from '../../../../redux/rest.slice';
import { IppIndustrySample } from '@rcp/types';
import { Resource, localizationService } from 'src/services';

export const ippSamplesSlice = new RestSlice<IppIndustrySample>(
	localizationService.getLocalizedString('ipp.samples.samplesDraft'),
	Resource.IppIndustrySamples
);
export default ippSamplesSlice.rests.reducer;
